import 'css-chunksrc/client/common/filterMenu/roles/role/styles.scss';export default {
  "role": "_role_1po0w_1",
  "name": "_name_1po0w_11"
};